module.exports = __webpack_public_path__ + "img/4.e4f5eb84.png";